module.exports = __webpack_public_path__ + "static/img/bluecompass-intro.59bfbd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/bluecompass-intro.jpg
// module id = dT2T
// module chunks = 0